import { createAction } from '@reduxjs/toolkit';
import { AppState } from './model';

enum AppAction {
  setMenu = '@app/setMenu',
  openMenu = '@app/openMenu',
  setAppLoading = '@app/setAppLoading',
  setResolution = '@app/setResolution',
}

const setMenu = createAction<AppState['opened']>(AppAction.setMenu);
const openMenu = createAction<AppState['menu']>(AppAction.openMenu);
const setAppLoading = createAction<AppState['appLoading']>(AppAction.setAppLoading);
const setResolution = createAction<AppState['resolution']>(AppAction.setResolution);

export const appAction = {
  setMenu,
  openMenu,
  setAppLoading,
  setResolution,
};
